import { memo } from "react";
import {
  ProgressIconsCentered,
  ProgressIconsWithText,
  ProgressMinimalIcons,
  ProgressMinimalIconsConnected,
  ProgressMinimalIconsConnectedProps,
  ProgressMinimalIconsProps,
  ProgressStepContainerProps,
  ProgressTextWithLine,
  ProgressTextWithLineProps,
  ProgressTextWithTextProps
} from "../../ProgressSteps/ProgressSteps";
import { ProgressStepProps } from "../../ProgressSteps/ProgressSteps/types";

export type ProgressStepWrapperProps =
  (Omit<ProgressMinimalIconsConnectedProps, "steps" | "currentStep"> & { typeStepper?: "progressMinimalIconsConnected" }) |
  (Omit<ProgressMinimalIconsProps, "steps" | "currentStep"> & { typeStepper?: "progressMinimalIcons" }) |
  (Omit<ProgressTextWithLineProps, "steps" | "currentStep"> & { typeStepper?: "progressTextWithLine" }) |
  (Omit<ProgressTextWithTextProps, "steps" | "currentStep"> & { typeStepper?: "progressIconsWithText" }) |
  (Omit<ProgressStepContainerProps, "steps" | "currentStep"> & { typeStepper?: "progressIconsCentered" });

export const ProgressStepWrapper = memo<ProgressStepWrapperProps & Pick<ProgressStepProps, "steps" | "currentStep">>(({
  typeStepper,
  ...props
}) => {
  switch (typeStepper) {
    case "progressIconsCentered":
      return <ProgressIconsCentered {...props} />;
    case "progressTextWithLine":
      return <ProgressTextWithLine {...props} />;
    case "progressMinimalIconsConnected":
      return <ProgressMinimalIconsConnected {...props} />;
    case "progressIconsWithText":
      return <ProgressIconsWithText {...props} />;
    case "progressMinimalIcons":
      return <ProgressMinimalIcons {...props} />;
    default:
      return null;
  }
});